import React from "react";
import { Table, Tag, Space } from "antd";
import { FiCheckCircle, FiAlertCircle, FiInfo } from "react-icons/fi";

export default function UpdateHistoryTab() {
	const updateData = [
		{
			id: 1,
			updateId: "UPD-2024-001",
			assetName: "SCADA-SERVER-01",
			updateType: "Security Patch",
			version: "3.5.2",
			timestamp: "2024-01-15 14:30:22",
			status: "Completed",
			details: "Critical security vulnerabilities fixed",
		},
		{
			id: 2,
			updateId: "UPD-2024-002",
			assetName: "HMI-WORKSTATION-02",
			updateType: "Feature Update",
			version: "2.2.0",
			timestamp: "2024-01-14 11:15:45",
			status: "Completed",
			details: "New UI components and performance improvements",
		},
		{
			id: 3,
			updateId: "UPD-2024-003",
			assetName: "INDUSTRIAL-PLC-03",
			updateType: "Security Patch",
			version: "4.2.4",
			timestamp: "2024-01-13 09:45:33",
			status: "Completed",
			details: "Authentication mechanism updated",
		},
		{
			id: 4,
			updateId: "UPD-2024-004",
			assetName: "COMPUTER-WS-06",
			updateType: "Feature Update",
			version: "1.9.1",
			timestamp: "2024-01-12 16:20:11",
			status: "Completed",
			details: "Bug fixes and stability improvements",
		},
		{
			id: 5,
			updateId: "UPD-2024-005",
			assetName: "NETWORK-DEVICE-04",
			updateType: "Firmware Update",
			version: "2.0.2",
			timestamp: "2024-01-11 13:05:50",
			status: "Completed",
			details: "Network optimization and protocol updates",
		},
		{
			id: 6,
			updateId: "UPD-2024-006",
			assetName: "VOIP-PHONE-07",
			updateType: "Minor Update",
			version: "1.5.1",
			timestamp: "2024-01-10 10:30:25",
			status: "Completed",
			details: "Voice codec improvements",
		},
	];

	const getUpdateTypeColor = (type) => {
		const colorMap = {
			"Security Patch": "#ff4d4f",
			"Feature Update": "#1890ff",
			"Firmware Update": "#faad14",
			"Minor Update": "#52c41a",
		};
		return colorMap[type];
	};

	const getUpdateTypeIcon = (type) => {
		const iconMap = {
			"Security Patch": <FiAlertCircle size={16} />,
			"Feature Update": <FiInfo size={16} />,
			"Firmware Update": <FiInfo size={16} />,
			"Minor Update": <FiCheckCircle size={16} />,
		};
		return iconMap[type];
	};

	const columns = [
		{
			title: "Update ID",
			dataIndex: "updateId",
			key: "updateId",
			width: 120,
			render: (text) => <span>{text}</span>,
		},
		{
			title: "Asset Name",
			dataIndex: "assetName",
			key: "assetName",
			width: 150,
			render: (text) => <span>{text}</span>,
		},
		{
			title: "Type",
			dataIndex: "updateType",
			key: "updateType",
			width: 130,
			render: (type) => <Tag color={getUpdateTypeColor(type)}>{type}</Tag>,
		},
		{
			title: "Version",
			dataIndex: "version",
			key: "version",
			width: 100,
			render: (text) => <span>{text}</span>,
		},
		{
			title: "Details",
			dataIndex: "details",
			key: "details",
			width: 250,
			render: (text) => <span>{text}</span>,
		},
		{
			title: "Timestamp",
			dataIndex: "timestamp",
			key: "timestamp",
			width: 150,
			render: (text) => <span>{text}</span>,
		},
		{
			title: "Status",
			dataIndex: "status",
			key: "status",
			width: 100,
			render: (status) => (
				<Tag color="green">
					{status}
				</Tag>
			),
		},
	];

	return (
		<div className="card mt-5">
			<div className="card-body">
				<Table
					columns={columns}
					dataSource={updateData}
					rowKey="id"
					className="table antd-override mb-0"
					pagination={{
						pageSize: 10,
						className: 'mb-0',
						showTotal: (total, range) => (
							<span>
								{range[0]} to {range[1]} of {total} updates
							</span>
						),
					}}
					scroll={{ x: 1200 }}
				/>
			</div>
		</div>
	);
}
